import { FC } from 'react';
import PaymentsRunTableTile from 'components/shared/PaymentsRunTableTile/PaymentsRunTableTile';

const PaymentRuns: FC = () => <PaymentsRunTableTile withPopups />;

export default PaymentRuns;
